import { render, staticRenderFns } from "./BoxArchiveExplorePastBoxesBanner.vue?vue&type=template&id=2065c6aa&scoped=true&"
import script from "./BoxArchiveExplorePastBoxesBanner.vue?vue&type=script&lang=js&"
export * from "./BoxArchiveExplorePastBoxesBanner.vue?vue&type=script&lang=js&"
import style0 from "./BoxArchiveExplorePastBoxesBanner.vue?vue&type=style&index=0&id=2065c6aa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065c6aa",
  null
  
)

export default component.exports